<template>
    <ion-page>
      <ion-header>
        <ion-toolbar>
          <!-- <ion-buttons slot="start" @click="goBack()">
            <ion-icon :icon="arrowBackOutline" />
          </ion-buttons> -->
          <ion-title>Search</ion-title>
        </ion-toolbar>
        <ion-searchbar ref="searchRef" v-model="searchQuery" placeholder="Search for Teams, Clubs and Competitions" @ionInput="debouncedSearch" autofocus></ion-searchbar>
      </ion-header>
      <ion-content>
        <div v-if="!searchQuery && !results.length" class="centered-content">
          <h4 class="c-white mt-30 text-center px-20">Start typing to search</h4>
        </div>
        <div v-else-if="results.length">
          <div v-for="key in Object.keys(groupedResults)" :key="key">
            <h3 class="c-white mt-30 px-20">{{ capitalize(key) }}</h3>
            <div :key="key" class="state-list">
              <div v-for="result in groupedResults[key]" :key="result._id">
                <entity-card v-if="['team', 'association', 'club', 'state'].includes(result.type)" :entity="result" @click="navigateTo(result.type, result._id, false)" />
                <CompetitionCard v-if="result.type === 'competition'" :comp="result" @click="navigateTo(result.type, result._id, result)" />
              </div>
            </div>
          </div>
          
        </div>
        <div v-else-if="searchQuery">
          <p>No results found.</p>
        </div>
      </ion-content>
    </ion-page>
  </template>
  
<script>
import { arrowBackOutline } from "ionicons/icons";
import EntityCard from '../components/EntityCard.vue';
import CompetitionCard from "../components/CompetitionCard.vue";
import _ from 'lodash';
  
export default {
  components: {
    EntityCard,
    CompetitionCard,
  },
  data() {
    return {
      searchQuery: '',
      results: [],
      arrowBackOutline,
    };
  },
  computed: {
    groupedResults() {
      const { results } = this;
      const grouped = _.groupBy(results, 'type');
      return grouped
    },
    entity() {
      return this.$store.getters['national/getEntity'];
    },
  },
  created() {
    this.debouncedSearch = _.debounce(this.handleSearch, 500);
  },
  mounted() {
    setTimeout(() => this.$refs.searchRef.$el.setFocus(), 500)
  },
  methods: {
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    async handleSearch() {
      const query = this.searchQuery;
      if (query) {
        const params = { search: query };
        if(this.entity && this.entity._id){
          params.entityId = this.entity._id;
          params.entityType = this.entity.level;
        }
        try {
          const response = await this.$http.get("/assemble/api/v1/live/search", {
            params
          });
          this.results = response.data.data || [];
        } catch (error) {
          console.error("Error during search:", error);
        }
      } else {
        this.results = [];
      }
    },
    navigateTo(type, id, entity) {
      if(this.entity && this.entity.level && this.entity.name){
        this.$router.push(`/c/${this.entity.level}/${this.entity.name}/${type}s/${id}`);
        return;
      } else {
        this.$router.push(`/${type}s/${id}`);
      }

      // if (type === "competition") {
      //   this.$router.push(`/competitions/${id}`);
      // } else {
      //   this.$router.push(`/${type}s/${id}`);
      // }
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
  
  <style scoped lang="scss">
  
  .centered-content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }  
  // .option-row {
  //   display: flex;
  //   gap: 1rem;
  //   position: relative;
  // }
  .logo {
    max-width: 30vw;
    // height: 10rem;
  }
  
  ion-input {
    --background: #191a1d !important;
  }
  
  h5 {
    margin-top: 0;
  }
  
  ion-title {
    font-family: 'Cairo';
  }
  
  ion-grid {
    white-space: nowrap;
     --offset-bottom: auto!important;
    --overflow: hidden;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  
  .header-bar {
    padding: 0.5rem;
  }
  
  .search-bar {
    --background: #191a1d;
    --color: #fff;
    --placeholder-color: #fff;
    --icon-color: #fff;
    --clear-button-color: #fff;
    --border-radius: 1rem;
    color: #fff;
    margin: 1rem 2rem;
    max-width: 85%;
    background: #191a1d !important;
    border: 1px solid #616161;
    border-radius: 1rem;
    input {
      --background: #191a1d;
      background: #191a1d;
    }
  }
  
  
  .round-text {
    color: #fff;
    font-family: 'Cairo';
    text-align: center;
    font-size: 14px;
    text-transform: uppercase;
    // text-decoration: underline;
    // text-decoration-color: $highlight;
  }
  
  .state-list {
    margin: 1rem;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(10rem, 22rem));
    gap: 0.5rem;
    .state-option {
      &:hover { cursor: pointer; }
      display: grid;
      // flex-direction: column;
      // justify-content: center;
      align-items: center;
      gap: 1rem;
      background: #17181B;
      border-radius: 1rem;
      padding: 1rem 1rem;
    }
  }
  
  ion-label {
    color: white;
    font-family: 'Cairo';
    font-size: 0.8rem;
  }
  
  
  ion-item {
    --padding-start: 15px;
    --padding-end: 15px;
  }
  .flex {
    display: flex;
  }
  .flex-column {
    flex-direction: column;
  }
  .align-center {
    align-items: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-around {
    justify-content: space-around;
  }
  .light-text {
    font-size: 14px;
    font-weight: 400;
    text-transform: capitalize;
  }
  .normal-text {
    font-size: 15px;
    font-weight: 600;
    text-transform: capitalize;
  }
  .bold-text {
    font-size: 16px;
    font-weight: bold;
  }
  .score-text {
    font-size: 30px;
    line-height: 30px;
    font-weight: 700;
    /* color: rgba(8, 48, 109, 0.5); */
    color: white;
  }
  
  .header {
    --background: #1a2933 !important;
    color: white;
  }
  
  .custom-segment {
    background: $background !important;
  }
  
  .custom-segment ::before {
    border-left: none;
  }
  
  .custom-segment .segment-button-checked {
    color: $primary;
    --indicator-box-shadow: none;
    border-bottom: 2px solid $primary;
  }
  
  .bye-card {
    margin-inline: 1.5rem;
    position: relative;
    border-radius: 24px;
    cursor: pointer;
    box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
    -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
    
    font-family: 'BrownStd-Regular';
    color: white;
    background: transparent;
    .round-text {
      margin-top: 0.5rem;
      margin-bottom: 1rem;
    }
  }
  .custom-card {
    border-radius: 24px;
    cursor: pointer;
    // box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
    // -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
    font-family: 'BrownStd-Regular';
    font-size: 1.2rem;
    line-height: 137.4%;
    letter-spacing: 0.02em;
    color: white;
     box-shadow: none;
    background: #171717 !important;
    margin-inline: 1.5rem;
  }
  .custom-card .card-content-ios {
    padding: 10px;
  }
  
  .custom-card .promoted-header {
    font-family: 'BrownStd-Regular';
    text-align: center;
    font-size: .9rem;
    font-weight: 600;
    text-transform: capitalize;
    line-height: 137.4%;
    letter-spacing: 0.02em;
    color: #2d3a45;
  }
  
  .list-ios, .list-md {
    padding: 0;
    background: 0;
  }
  
  ion-item {
    --background: #232528;
    --color: white;
  }
  
  .custom-segment ion-label {
    margin-bottom: 0;
  }
  
  ion-content {
    background: $background;
    --background: $background;
    --offset-bottom: auto!important;
    --overflow: hidden;
    overflow: auto;
  }
  
  ion-content::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: rgba(0,0,0,0.3);
  }
  
  ion-content::-webkit-scrollbar
  {
    width: .35rem;
    background-color: rgba(0,0,0,0.3);
  }
  
  @media only screen and (max-width: 768px) {
    ion-content::-webkit-scrollbar {
      width: .15rem;
      background-color: rgba(0,0,0,0.3);
    }
  }
  
  ion-content::-webkit-scrollbar-thumb
  {
    background-color: #888;
  }
  
  
  .overlay {
    background: $background;
    // background: $primary;
    padding: 0rem;
  }
  
  ion-toolbar, ion-item {
    --border-width: 0 !important;
    --background: $background;
    --color: white;
  }
  
  ion-segment-button {
    --background-hover: white !important;
    --color-hover: $highlight !important;
    --color-checked: $highlight !important;
  }
  
  .custom-segment {
    border: none;
    /* background: white; */
    border-radius: 0px;
    border-bottom: 1px solid rgba(177, 177, 177, 0.3);
    // padding-top: 1rem;
    border: none;
    background: none;
     display: flex;
    // justify-content: center;
    /* border-radius: 1rem !important; */
  }
  
  .custom-segment ::before {
    border-left: none;
  }
  
  .custom-segment .in-segment {
    color: rgba(177, 177, 177, 1);
    font-size: 1.3rem;
    // background-color: rgba($primary, .7);
  }
  
  .custom-segment .segment-button-checked {
    color: rgb(234 68 68);
    border-radius: 0;
    margin-bottom: 0;
    // background-color: rgba($primary, .7);
    color: $highlight;
    font-size: 1.3rem;
    font-weight: 500;
    --indicator-height: 0;
    --indicator-box-shadow: none;
    /* --indicator-color: rgb(234, 68, 68, 0.7);
    --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1); */
    border-bottom: 3px solid $highlight;
  }
  .custom-segment-ladder {
    // border: none;
    margin: 0 auto;
    margin-top: 1rem;
    display: flex;
    width:70%;
    justify-content: center;
    border-radius: 0.6rem !important;
  }
  
  .custom-segment-ladder-button{
    flex-basis: 50%;
  }
  
  
  .custom-segment-ladder ::before {
    border-left: none;
  }
  
  .custom-segment-ladder .in-segment {
    color: rgba(177, 177, 177, 1);
    background-color: rgba($primary, .2);
  }
  
  .custom-segment-ladder .segment-button-checked {
    color: rgb(234 68 68);
    // margin-bottom: 0;
    background-color: rgba($primary, .7);
    color: $highlight;
    font-weight: 400;
    // --indicator-height: 0;
    // --indicator-box-shadow: none;
    //  --indicator-color: rgb(234, 68, 68, 0.7);
    // --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1); 
    // border-bottom: 3px solid $highlight;
  }
  
  .empty-container {
    height: 60vh;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: none;
    -webkit-box-shadow: none;
  }
  
  .empty-container ion-card {
    padding: 4rem;
    border-radius: 1rem;
    background: transparent;
    box-shadow: none;
    -webkit-box-shadow: none;
  }
  
  .empty-placeholder {
    align-items: flex-start;
    font-family: 'BrownStd-Regular';
    font-style: normal;
    font-weight: bold;
    font-size: 1.2rem;
    line-height: 137.4%;
    /* margin-bottom: 1rem; */
    padding-left: 0;
  
    letter-spacing: 0.02em;
  
    color: white;
  }
  
  .state-name {
    font-size: 0.8rem;
    white-space: break-spaces;
  }
  
  ion-select::part(icon) {
    margin-left: 0.5rem;
    color: white !important;
    opacity: 0.85;
  }
  
  </style>